import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "./api";

export default function Login() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      await login(password);
      navigate("/sstoa", { replace: true });
    } catch (err) {
      setError(err.message || "로그인에 실패했습니다.");
      setBusy(false);
    }
  }

  return (
    <div className="sstoa-root">
      <div className="sstoa-login">
        <form className="sstoa-login__card" onSubmit={onSubmit}>
          <h1 className="sstoa-login__brand">SSTOA</h1>
          <p className="sstoa-login__sub">I.META 회사 관리 시스템</p>

          {error && <div className="sstoa-error" style={{ marginBottom: 14 }}>{error}</div>}

          <div className="sstoa-field" style={{ marginBottom: 16 }}>
            <label htmlFor="sstoa-pw">비밀번호</label>
            <input
              id="sstoa-pw"
              className="sstoa-input"
              type="password"
              autoFocus
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={busy}
            />
          </div>

          <button type="submit" className="sstoa-btn sstoa-btn--primary" style={{ width: "100%" }} disabled={busy}>
            {busy ? "확인 중…" : "로그인"}
          </button>
        </form>
      </div>
    </div>
  );
}
